module.exports = __webpack_public_path__ + "img/AdamNeuhaus-PatrickKluivert.0308471f.webp";